<template>
  <div>
    <!-- Example split danger button -->
    <template v-if="downloading">
      <div class="image-fetching text-center">
        <spinner spinner-class-list="text-secondary"></spinner>
      </div>
    </template>
    <div
      v-else-if="!downloading && fetchedResource && fetchedResource[0] && fetchedResourceBig && fetchedResourceBig[0]"
      class="d-flex flex-column justify-center align-center img-zoom-container img-container"
    >
      <signed-receipt-badge  v-if="receipt.media.signed" :signingDate="$t('transactions_receipt_signed_date', {signedCreatedAt :$moment(receipt.media.createdAt).format('DD/MM/YYYY')})"/>
      <div
        v-if="!processed"
        class="processing-receipt"
      >
        <spinner :spinnerContainerClass="''"></spinner>
        <span>{{$t('transactions_receipt_processing')}}</span>
      </div>
      <img
        ref="myimage"
        class="image"
        :src="`${fetchedResource || fetchedResource[0]}`"
        width="300"
        height="240"
        alt="image-thumb"
        @click="emitClick"
        @mouseover="imageZoom"
        @mouseleave="hoverOnImage = false"
        @mousemove="moveLens"
        @error="setFallbackImage"
      >
      <div
        v-show="hoverOnImage"
        ref="containerResult"
        class="img-zoom-container-result"
      >
        <div
          ref="myresult"
          class="img-zoom-result"
        ></div>
      </div>
      <div class="img-type">
        <span>{{$t(`transactions_receipt_type_${type}`)}}</span>
        <dropdown
          v-if="!dropdownHidden"
          class="mr-1"
          :close-on-click-inside="false"
          :sizeClass="'Fuell-Dropdown--button-dots Fuell-Dropdown--button-dots-small'"
        >
          <div
            class="clickable"
            role="button"
            @click="changeFile"
          >{{type === 'BILL' ? $t('transactions_receipt_type_change_RECEIPT') : $t('transactions_receipt_type_change_BILL')}}</div>
          <div
            class="clickable"
            role="button"
            @click="downloadFile"
          >{{$t('ACTION_DOWNLOAD')}}</div>
          <div
            class="clickable"
            role="button"
            @click="deleteFile"
          >{{$t('media_viewer_delete_resource')}}</div>
        </dropdown>
      </div>
    </div>
  </div>
</template>

<script>
import { MEDIA_TYPE } from '@/modules/transactions/_constants/MediaType'
import _mediaResourceHandlerMixin from '@/components/Commons/_mixins/_mediaResourceHandlerMixin'
import Spinner from '@/components/Commons/Spinner'
import Dropdown from '@/components/Commons/Dropdown'
import SignedReceiptBadge from '../../modules/transactions/_components/_shared/SignedReceiptBadge.vue'
export default {
  name: 'MediaResourceThumbViewer',
  mixins: [_mediaResourceHandlerMixin],
  components: { Spinner, Dropdown, SignedReceiptBadge },
  props: {
    dropdownHidden: {
      type: Boolean,
      default: false
    },
    file: {
      type: File,
      default: null
    },
    resourceIndex: {
      type: Number
    },
    receipt: {
      type: Object,
      default: () => { }
    },
    transactionId: {
      type: Number,
      default: null
    }
  },
  computed: {
    MEDIA_TYPE () {
      return MEDIA_TYPE
    },
    resourceId () {
      return this.receipt.media?.id
    },
    type () {
      return this.receipt.media?.type || this.receipt.media?.isBill ? MEDIA_TYPE.BILL : MEDIA_TYPE.RECEIPT
    },
    processed () {
      return this.receipt.processed
    }
  },
  data () {
    return {
      fetchedResource: null,
      downloading: false,
      hoverOnImage: false,
      cx: 7.5,
      cy: 7.5
    }
  },
  methods: {
    changeFile () {
      this.$emit('handleChangeFileType', this.resourceId, this.type)
    },
    downloadFile () {
      this.$emit('handleDownloadFile', this.resourceId)
    },
    deleteFile () {
      this.$emit('handleDeleteFile', this.resourceId)
    },
    setFallbackImage (event) {
      event.target.src = require('@/assets/img/pdf.png')
    },
    emitClick () {
      if (this.file) {
        this.$emit('click', this.resourceIndex)
      } else {
        this.$emit('click', this.resourceId)
      }
    },
    imageZoom () {
      if (this.$refs.containerResult?.style) {
        this.$refs.containerResult.style.left = `${this.$refs?.myimage?.parentElement?.parentElement?.parentElement?.offsetParent?.offsetLeft - this.$refs?.myimage?.parentElement?.offsetLeft + ((this.$refs?.myimage?.parentElement?.parentElement?.parentElement?.offsetParent?.offsetWidth / 2) - (300 / 2))}px`
      }
      if (this.$refs.myresult?.style) {
        this.$refs.myresult.style.backgroundImage = `url(${this.fetchedResourceBig})`
      }
      this.hoverOnImage = true
    },
    moveLens (e) {
      var pos, x, y
      pos = this.getCursorPos(e)
      x = pos.x - 20
      y = pos.y - 20
      if (this.$refs.myimage && x > this.$refs.myimage.width - 40) { x = this.$refs.myimage.width - 40 }
      if (x < 0) { x = 0 }
      if (this.$refs.myimage && y > this.$refs.myimage.height - 40) { y = this.$refs.myimage.height - 40 }
      if (y < 0) { y = 0 }
      if (this.$refs.myresult?.style) {
        this.$refs.myresult.style.backgroundPosition = '-' + (x * this.cx) + 'px -' + (y * this.cy) + 'px'
      }
    },
    getCursorPos (e) {
      var a
      var x = 0
      var y = 0
      e = e || window.event
      a = this.$refs.myimage ? this.$refs.myimage?.getBoundingClientRect() : 0
      x = e.pageX - a.left
      y = e.pageY - a.top
      x = x - window.pageXOffset
      y = y - window.pageYOffset
      return { x: x, y: y }
    }
  },
  async created () {
    if (this.file) {
      await this.fileTypeHandler(this.file, this.file.type)
    } else {
      this.fetchedResource = await this.fetchSmallThumbnail()
    }
    await this.getBigImage()
  }
}
</script>

<style lang="scss" scoped>
.processing-receipt {
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(22, 39, 67, 0.6);
  flex-direction: column;
  height: 100%;
  width: 100%;
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--text-button);
  }
}
.img-type {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 24px;
  padding-left: 6px;
  span {
    font-weight: 400;
    font-size: 12px;
    line-height: 16px;
    color: var(--gray);
  }
}
.img-container {
  height: 140px;
  border-radius: 4px;
  border: 1px solid #e9eef2;
}
.image {
  width: 105px;
  height: 120px;
  overflow: hidden;
  background-size: cover;
  background-repeat: no-repeat;
  border-bottom: 1px solid #e9eef2;
  background-position: -3px -9px;
  cursor: pointer;
}
.image:hover {
  border: 1px solid var(--gray);
  transition: border 0.5s ease-out;
}
.image-fetching {
  width: 105px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.img-zoom-container {
  position: relative;
}

.img-zoom-result {
  /*set the size of the result div:*/
  width: 100%;
  height: 100%;
  background-repeat: no-repeat;
  background-size: 772px 992px;
}
.img-zoom-container-result {
  position: absolute;
  top: 141px;
  border: 1px solid var(--text-body);
  border-radius: 16px;
  padding: 5px 10px 4px;
  width: 300px;
  height: 300px;
  z-index: 1;
  background: var(--text-body);
}
</style>
<style lang="scss">
.img-type {
  .Fuell-Dropdown--container {
    .Fuell-Dropdown--content {
      padding: 8px 8px;
      width: 120px;
      font-size: 15px;
      text-align: left;
      color: var(--gray);

      .clickable {
        &:first-child {
          line-height: 20px;
          margin-bottom: 5px;
          margin-top: 5px;
        }
        &:nth-child(2) {
          margin-bottom: 5px;
        }
      }
    }
  }
}
</style>
